import Vue from "vue";
import { formatDateRestore } from "../utils/date";

const state = {
  fontSize: 0,
  highContrast: false,
  showBrowserAlert: false,
  loading: false,
  toast: null,
  errorToast: null,
  usuario: {},
  stepParcelamento: 1,
  faturaSelected: {},
  initialStateFaturaSelected: {},
  numberOfElementsFaturas: 0,
  selecionarBeneficiario: [],
  numberOfElementsListFaturaPorBeneficiario: 0,
  visualizaParcelamento: {},
  numberOfElementsVisualizaParcelamento: 0,
  showModalConfirmaBenefDadosAtualizados: false,
  filtro: {},
  paginacao: {
    page: 1,
    rowsPerPage: 5
  }
};

const getters = {
  getErrorToast: state => state.errorToast,
  getFontSize: state => state.fontSize,
  getHighContrast: state => state.highContrast,
  getShowBrowserAlert: state => state.showBrowserAlert,
  getShowLoading: state => state.loading,
  getToast: state => state.toast,
  getUsuario: state => state.usuario,
  faturaSelected: state => ({
    ...state.faturaSelected,
    dataPrimVencimento: formatDateRestore(
      state.faturaSelected.dataPrimVencimento
    )
  }),
  getCodigoParcelamento: state => state.faturaSelected.codigoParcelamento,
  getShowModalConfirmaBenefDadosAtualizados: state =>
    state.showModalConfirmaBenefDadosAtualizados,
  getFiltro: state => state.filtro,
  getPaginacao: state => state.paginacao
};

const mutations = {
  clearAll(state) {
    state.fontSize = 0;
    state.highContrast = false;
    state.showBrowserAlert = false;
    state.loading = false;
    state.toast = null;
    state.errorToast = null;
    state.usuario = {};
    state.stepParcelamento = 1;
    state.filtro = {};
    state.paginacao = {};
  },
  clearToast(state) {
    state.toast = null;
  },
  clearErrorToast(state) {
    state.errorToast = null;
  },
  decrementFont(state) {
    if (state.fontSize > 0) {
      state.fontSize--;
    }
  },
  disableHighContrast(state) {
    state.highContrast = false;
  },
  enableHighContrast(state) {
    state.highContrast = true;
  },
  incrementFont(state) {
    if (state.fontSize < 4) {
      state.fontSize++;
    }
  },
  resetFont(state) {
    state.fontSize = 0;
  },
  setErrorToast(state, error) {
    state.errorToast = error;
  },
  setFontSize(state, size) {
    state.fontSize = size;
  },
  setHighContrast(state, contrast) {
    state.highContrast = contrast;
  },
  setShowBrowserAlert(state, value) {
    state.showBrowserAlert = value;
  },
  setShowLoading(state, value) {
    state.loading = value;
  },
  setToast(state, content) {
    state.toast = content;
  },
  setUsuario(state, content) {
    state.usuario = content;
  },
  setFiltro(state, content) {
    state.filtro = content;
  },
  setPaginacao(state, content) {
    state.paginacao = content;
  },
  updateField(state, { property, value }) {
    Vue.set(state.faturaSelected, property, value);
  },
  updateFieldQtdParcelas(state, { property, value, item }) {
    state.selecionarBeneficiario = state.selecionarBeneficiario.map(fatura => ({
      ...fatura,
      [property]:
        fatura.codigoBeneficiario === item.codigoBeneficiario
          ? value
          : fatura[property]
    }));
  },
  updateFieldQtdParcelasAllBeneficiario(state, { property, value }) {
    state.selecionarBeneficiario.map(fatura =>
      Vue.set(fatura, property, value)
    );
  },
  GENERIC_MUTATION(state, { property, payload }) {
    state[property] = payload;
  },
  nextStep(state) {
    if (state.stepParcelamento < 3) {
      state.stepParcelamento++;
    }
  },
  previousStep(state) {
    if (state.stepParcelamento > 0) {
      state.stepParcelamento--;
    }
  },
  resetStep(state) {
    state.stepParcelamento = 1;
  },
  setShowModalConfirmaBenefDadosAtualizados(state, value) {
    state.showModalConfirmaBenefDadosAtualizados = value;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations
};
